/** @format */

import React from 'react';
import handleError from '../components/form/handle_error';

/**
 * I'll try my best to display any kind of error sent to me
 * Otherwise I'll just put it out to text
 */
class ErrorDisplay extends React.Component {
    static defaultProps = {
        errorMessage: '',
        hasError: false,
        className: '',
        listView: false, // Show in a list
        listItemClassName: '' // Class added to each list item
    };
    constructor(props) {
        super(props);
    }

    render() {
        if (this.props.hasError) {
            if (this.props.listView) {
                return (
                    <ul className={this.props.className}>
                        {this.props.errorMessage.split(' AND ').map((message, index) => (
                            <li className={this.props.listItemClassName} key={index}>
                                {message}
                            </li>
                        ))}
                    </ul>
                );
            }
            return <span className={this.props.className}>{this.props.errorMessage}</span>;
        }
        return null;
    }
}

export default handleError(ErrorDisplay);
